'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findIdentifiers;
function findIdentifiers(path) {
  var found = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (Array.isArray(path)) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = path[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        findIdentifiers(item, found);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return found;
  }
  if (path.isIdentifier()) {
    found.push(path);
  } else if (path.isAssignmentPattern()) {
    findIdentifiers(path.get('left'), found);
  } else if (path.isArrayPattern()) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = path.get('elements')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var element = _step2.value;

        findIdentifiers(element, found);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  } else if (path.isObjectPattern()) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = path.get('properties')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var property = _step3.value;

        findIdentifiers(property.get('value'), found);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  } else if (path.isRestElement() || path.isRestProperty()) {
    findIdentifiers(path.get('argument'), found);
  }
  return found;
}


//////////////////
// WEBPACK FOOTER
// ../babel-plugin-flow-runtime/lib/findIdentifiers.js
// module id = 176
// module chunks = 0